import React from 'react';
import GamificationServices from '../services/GamificationServices';

const TierBadge = ({ tier, size = 'md', showIcon = true, showName = true }) => {
  if (!tier) {
    return (
      <span className="tier-badge tier-bronze">
        {showIcon && <span className="tier-icon">🥉</span>}
        {showName && 'Bronze'}
      </span>
    );
  }

  const getSizeClass = () => {
    switch (size) {
      case 'sm': return 'tier-badge-sm';
      case 'lg': return 'tier-badge-lg';
      case 'xl': return 'tier-badge-xl';
      default: return '';
    }
  };

  const getTierClass = () => {
    return `tier-${tier.tier || 'bronze'}`;
  };

  const getTierEmoji = () => {
    return GamificationServices.getTierEmoji(tier.tier);
  };

  return (
    <span className={`tier-badge ${getTierClass()} ${getSizeClass()}`}>
      {showIcon && <span className="tier-icon">{getTierEmoji()}</span>}
      {showName && (tier.name || 'Bronze')}
    </span>
  );
};

export default TierBadge;